export * from "./legacy";
export {
    servicesApi,
    useGetServicesQuery,
    useUpdateServicePaidMutation,
    useAssignServicesMutation,
    useGetAllServicesQuery,
    useGetAllServicesCompressedQuery,
    useCreateServiceMutation,
    useUpdateServiceMutation,
    useUpdateServiceArchiveMutation,
    useCalculateSuccessFeeMutation,
    useGenerateServiceExcelMutation,
    useGetServicesOnConfirmationQuery,
} from "./rtk";
